export const DictionaryPhotoshop_zh_CN = [
    {
        id: 1,
        label: 'Photoshop > 关于 Photoshop...',
        placement: 'MenuBar',
        name: '关于 Photoshop...',
    },
    {
        id: 10,
        label: '文件 > 新建...',
        placement: 'MenuBar',
        name: '新建...',
    },
    {
        id: 20,
        label: '文件 > 打开...',
        placement: 'MenuBar',
        name: '打开...',
    },
    {
        id: 22,
        label: '文件 > 打开为智能对象...',
        placement: 'MenuBar',
        name: '打开为智能对象...',
    },
    {
        id: 30,
        label: '文件 > 存储',
        placement: 'MenuBar',
        name: '存储',
    },
    {
        id: 31,
        label: '文件 > 关闭',
        placement: 'MenuBar',
        name: '关闭',
    },
    {
        id: 32,
        label: '文件 > 存储为...',
        placement: 'MenuBar',
        name: '存储为...',
    },
    {
        id: 33,
        label: '文件 > 存储副本...',
        placement: 'MenuBar',
        name: '存储副本...',
    },
    {
        id: 34,
        label: '文件 > 恢复',
        placement: 'MenuBar',
        name: '恢复',
    },
    {
        id: 36,
        label: 'Photoshop > 退出 Photoshop',
        placement: 'MenuBar',
        name: '退出 Photoshop',
    },
    {
        id: 37,
        label: '文件 > 关闭全部',
        placement: 'MenuBar',
        name: '关闭全部',
    },
    {
        id: 46,
        label: '文件 > 关闭其它',
        placement: 'MenuBar',
        name: '关闭其它',
    },
    {
        id: 101,
        label: '编辑 > 还原(O)',
        placement: 'MenuBar',
        name: '还原(O)',
    },
    {
        id: 103,
        label: '编辑 > 剪切',
        placement: 'MenuBar',
        name: '剪切',
    },
    {
        id: 104,
        label: '编辑 > 拷贝',
        placement: 'MenuBar',
        name: '拷贝',
    },
    {
        id: 105,
        label: '编辑 > 粘贴',
        placement: 'MenuBar',
        name: '粘贴',
    },
    {
        id: 106,
        label: '编辑 > 清除',
        placement: 'MenuBar',
        name: '清除',
    },
    {
        id: 132,
        label: '编辑 > 重做(O)',
        placement: 'MenuBar',
        name: '重做(O)',
    },
    {
        id: 133,
        label: '编辑 > 切换最终状态',
        placement: 'MenuBar',
        name: '切换最终状态',
    },
    {
        id: 177,
        label: '文件 > 打印一份',
        placement: 'MenuBar',
        name: '打印一份',
    },
    {
        id: 1001,
        label: '窗口 > 排列 > 新建窗口',
        placement: 'MenuBar',
        name: '新建窗口',
    },
    {
        id: 1002,
        label: '视图 > 标尺',
        placement: 'MenuBar',
        name: '标尺',
    },
    {
        id: 1004,
        label: '视图 > 放大',
        placement: 'MenuBar',
        name: '放大',
    },
    {
        id: 1005,
        label: '视图 > 缩小',
        placement: 'MenuBar',
        name: '缩小',
    },
    {
        id: 1006,
        label: '图像 > 模式 > 位图(B)',
        placement: 'MenuBar',
        name: '位图(B)',
    },
    {
        id: 1007,
        label: '图像 > 模式 > 灰度(G)',
        placement: 'MenuBar',
        name: '灰度(G)',
    },
    {
        id: 1008,
        label: '图像 > 模式 > 双色调(D)',
        placement: 'MenuBar',
        name: '双色调(D)',
    },
    {
        id: 1009,
        label: '图像 > 模式 > 索引颜色(I)',
        placement: 'MenuBar',
        name: '索引颜色(I)',
    },
    {
        id: 1010,
        label: '图像 > 模式 > RGB 颜色',
        placement: 'MenuBar',
        name: 'RGB 颜色',
    },
    {
        id: 1011,
        label: '图像 > 模式 > CMYK 颜色',
        placement: 'MenuBar',
        name: 'CMYK 颜色',
    },
    {
        id: 1014,
        label: '图像 > 模式 > 多通道',
        placement: 'MenuBar',
        name: '多通道',
    },
    {
        id: 1016,
        label: '选择 > 取消选择(D)',
        placement: 'MenuBar',
        name: '取消选择(D)',
    },
    {
        id: 1017,
        label: '选择 > 全部(A)',
        placement: 'MenuBar',
        name: '全部(A)',
    },
    {
        id: 1018,
        label: '选择 > 反选',
        placement: 'MenuBar',
        name: '反选',
    },
    {
        id: 1019,
        label: '滤镜 > 上次滤镜操作',
        placement: 'MenuBar',
        name: '上次滤镜操作',
    },
    {
        id: 1021,
        label: '窗口 > 通道',
        placement: 'MenuBar',
        name: '通道',
    },
    {
        id: 1025,
        label: '窗口 > 画笔设置',
        placement: 'MenuBar',
        name: '画笔设置',
    },
    {
        id: 1029,
        label: '编辑 > 定义画笔预设...',
        placement: 'MenuBar',
        name: '定义画笔预设...',
    },
    {
        id: 1030,
        label: '图像 > 图像大小...',
        placement: 'MenuBar',
        name: '图像大小...',
    },
    {
        id: 1031,
        label: '图像 > 画布大小...',
        placement: 'MenuBar',
        name: '画布大小...',
    },
    {
        id: 1032,
        label: '文件 > 置入嵌入对象...',
        placement: 'MenuBar',
        name: '置入嵌入对象...',
    },
    {
        id: 1033,
        label: '选择 > 扩大选取',
        placement: 'MenuBar',
        name: '扩大选取',
    },
    {
        id: 1034,
        label: '选择 > 选取相似',
        placement: 'MenuBar',
        name: '选取相似',
    },
    {
        id: 1035,
        label: '选择 > 修改 > 边界...',
        placement: 'MenuBar',
        name: '边界...',
    },
    {
        id: 1036,
        label: '选择 > 修改 > 羽化...',
        placement: 'MenuBar',
        name: '羽化...',
    },
    {
        id: 1037,
        label: '图层 > 修边 > 去边...',
        placement: 'MenuBar',
        name: '去边...',
    },
    {
        id: 1038,
        label: '编辑 > 定义图案...',
        placement: 'MenuBar',
        name: '定义图案...',
    },
    {
        id: 1040,
        label: '编辑 > 选择性粘贴 > 贴入',
        placement: 'MenuBar',
        name: '贴入',
    },
    {
        id: 1042,
        label: '编辑 > 填充...',
        placement: 'MenuBar',
        name: '填充...',
    },
    {
        id: 1043,
        label: '编辑 > 描边...',
        placement: 'MenuBar',
        name: '描边...',
    },
    {
        id: 1044,
        label: '图像 > 裁剪',
        placement: 'MenuBar',
        name: '裁剪',
    },
    {
        id: 1045,
        label: '图像 > 模式 > 颜色表...',
        placement: 'MenuBar',
        name: '颜色表...',
    },
    {
        id: 1046,
        label: '窗口 > 颜色',
        placement: 'MenuBar',
        name: '颜色',
    },
    {
        id: 1052,
        label: '图像 > 模式 > Lab 颜色',
        placement: 'MenuBar',
        name: 'Lab 颜色',
    },
    {
        id: 1055,
        label: '窗口 > 信息',
        placement: 'MenuBar',
        name: '信息',
    },
    {
        id: 1058,
        label: '窗口 > 仿制源',
        placement: 'MenuBar',
        name: '仿制源',
    },
    {
        id: 1065,
        label: '窗口 > 路径',
        placement: 'MenuBar',
        name: '路径',
    },
    {
        id: 1080,
        label: '图像 > 裁切...',
        placement: 'MenuBar',
        name: '裁切...',
    },
    {
        id: 1081,
        label: '图像 > 显示全部',
        placement: 'MenuBar',
        name: '显示全部',
    },
    {
        id: 1093,
        label: '图像 > 陷印...',
        placement: 'MenuBar',
        name: '陷印...',
    },
    {
        id: 1098,
        label: '窗口 > 图层',
        placement: 'MenuBar',
        name: '图层',
    },
    {
        id: 1099,
        label: '图层 > 新建 > 图层...',
        placement: 'MenuBar',
        name: '图层...',
    },
    {
        id: 1100,
        label: '图层 > 删除 > 图层(L)',
        placement: 'MenuBar',
        name: '图层(L)',
    },
    {
        id: 1103,
        label: '图层 > 图层内容选项...',
        placement: 'MenuBar',
        name: '图层内容选项...',
    },
    {
        id: 1105,
        label: '视图 > 校样颜色',
        placement: 'MenuBar',
        name: '校样颜色',
    },
    {
        id: 1106,
        label: '视图 > 色域警告',
        placement: 'MenuBar',
        name: '色域警告',
    },
    {
        id: 1107,
        label: '编辑 > 合并拷贝',
        placement: 'MenuBar',
        name: '合并拷贝',
    },
    {
        id: 1108,
        label: '选择 > 修改 > 平滑...',
        placement: 'MenuBar',
        name: '平滑...',
    },
    {
        id: 1109,
        label: '选择 > 修改 > 扩展...',
        placement: 'MenuBar',
        name: '扩展...',
    },
    {
        id: 1110,
        label: '选择 > 修改 > 收缩...',
        placement: 'MenuBar',
        name: '收缩...',
    },
    {
        id: 1111,
        label: '窗口 > 选项',
        placement: 'MenuBar',
        name: '选项',
    },
    {
        id: 1112,
        label: '视图 > 像素长宽比校正',
        placement: 'MenuBar',
        name: '像素长宽比校正',
    },
    {
        id: 1114,
        label: '图层 > 隐藏图层',
        placement: 'MenuBar',
        name: '隐藏图层',
    },
    {
        id: 1115,
        label: '选择 > 选择并遮住...',
        placement: 'MenuBar',
        name: '选择并遮住...',
    },
    {
        id: 1119,
        label: '窗口 > 色板',
        placement: 'MenuBar',
        name: '色板',
    },
    {
        id: 1134,
        label: '图像 > 复制...',
        placement: 'MenuBar',
        name: '复制...',
    },
    {
        id: 1135,
        label: '图层 > 复制图层...',
        placement: 'MenuBar',
        name: '复制图层...',
    },
    {
        id: 1137,
        label: '文件 > 文件简介...',
        placement: 'MenuBar',
        name: '文件简介...',
    },
    {
        id: 1139,
        label: '图层 > 合并可见图层',
        placement: 'MenuBar',
        name: '合并可见图层',
    },
    {
        id: 1141,
        label: '图层 > 拼合图像',
        placement: 'MenuBar',
        name: '拼合图像',
    },
    {
        id: 1152,
        label: '选择 > 颜色范围...',
        placement: 'MenuBar',
        name: '颜色范围...',
    },
    {
        id: 1153,
        label: '图像 > 应用图像...',
        placement: 'MenuBar',
        name: '应用图像...',
    },
    {
        id: 1154,
        label: '编辑 > 渐隐(D)...',
        placement: 'MenuBar',
        name: '渐隐(D)...',
    },
    {
        id: 1156,
        label: '图层 > 图层蒙版 > 隐藏全部',
        placement: 'MenuBar',
        name: '隐藏全部',
    },
    {
        id: 1157,
        label: '图层 > 图层蒙版 > 显示全部',
        placement: 'MenuBar',
        name: '显示全部',
    },
    {
        id: 1158,
        label: '图层 > 图层蒙版 > 显示选区',
        placement: 'MenuBar',
        name: '显示选区',
    },
    {
        id: 1159,
        label: '图层 > 图层蒙版 > 启用(B)',
        placement: 'MenuBar',
        name: '启用(B)',
    },
    {
        id: 1161,
        label: '图像 > 模式 > 8 位/通道(A)',
        placement: 'MenuBar',
        name: '8 位/通道(A)',
    },
    {
        id: 1162,
        label: '图像 > 模式 > 16 位/通道(N)',
        placement: 'MenuBar',
        name: '16 位/通道(N)',
    },
    {
        id: 1163,
        label: '窗口 > 导航器',
        placement: 'MenuBar',
        name: '导航器',
    },
    {
        id: 1166,
        label: '图层 > 合并图层(E)',
        placement: 'MenuBar',
        name: '合并图层(E)',
    },
    {
        id: 1167,
        label: '窗口 > 图层复合',
        placement: 'MenuBar',
        name: '图层复合',
    },
    {
        id: 1168,
        label: '图层 > 图层蒙版 > 隐藏选区',
        placement: 'MenuBar',
        name: '隐藏选区',
    },
    {
        id: 1169,
        label: '文件 > 自动 > 创建快捷批处理...',
        placement: 'MenuBar',
        name: '创建快捷批处理...',
    },
    {
        id: 1170,
        label: '窗口 > 动作',
        placement: 'MenuBar',
        name: '动作',
    },
    {
        id: 1180,
        label: '文件 > 自动 > 批处理...',
        placement: 'MenuBar',
        name: '批处理...',
    },
    {
        id: 1188,
        label: '窗口 > 时间轴',
        placement: 'MenuBar',
        name: '时间轴',
    },
    {
        id: 1190,
        label: '视图 > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: '视图 > 打印尺寸',
        placement: 'MenuBar',
        name: '打印尺寸',
    },
    {
        id: 1192,
        label: '视图 > 按屏幕大小缩放',
        placement: 'MenuBar',
        name: '按屏幕大小缩放',
    },
    {
        id: 1194,
        label: '窗口 > 工具',
        placement: 'MenuBar',
        name: '工具',
    },
    {
        id: 1195,
        label: '视图 > 按屏幕大小缩放画板',
        placement: 'MenuBar',
        name: '按屏幕大小缩放画板',
    },
    {
        id: 1199,
        label: '窗口 > 历史记录',
        placement: 'MenuBar',
        name: '历史记录',
    },
    {
        id: 1200,
        label: '选择 > 载入选区...',
        placement: 'MenuBar',
        name: '载入选区...',
    },
    {
        id: 1202,
        label: '视图 > 像素长宽比 > 自定像素长宽比...',
        placement: 'MenuBar',
        name: '自定像素长宽比...',
    },
    {
        id: 1203,
        label: '视图 > 像素长宽比 > 删除像素长宽比...',
        placement: 'MenuBar',
        name: '删除像素长宽比...',
    },
    {
        id: 1204,
        label: '视图 > 像素长宽比 > 复位像素长宽比...',
        placement: 'MenuBar',
        name: '复位像素长宽比...',
    },
    {
        id: 1205,
        label: '视图 > 像素长宽比 > 方形',
        placement: 'MenuBar',
        name: '方形',
    },
    {
        id: 1206,
        label: '图像 > 模式 > 32 位/通道',
        placement: 'MenuBar',
        name: '32 位/通道',
    },
    {
        id: 1211,
        label: '编辑 > 预设 > 迁移预设',
        placement: 'MenuBar',
        name: '迁移预设',
    },
    {
        id: 1212,
        label: '编辑 > 指定配置文件...',
        placement: 'MenuBar',
        name: '指定配置文件...',
    },
    {
        id: 1213,
        label: '编辑 > 转换为配置文件(V)...',
        placement: 'MenuBar',
        name: '转换为配置文件(V)...',
    },
    {
        id: 1214,
        label: '编辑 > 预设 > 预设管理器...',
        placement: 'MenuBar',
        name: '预设管理器...',
    },
    {
        id: 1215,
        label: '编辑 > Adobe PDF 预设...',
        placement: 'MenuBar',
        name: 'Adobe PDF 预设...',
    },
    {
        id: 1217,
        label: '视图 > 实际大小',
        placement: 'MenuBar',
        name: '实际大小',
    },
    {
        id: 1223,
        label: '文字 > 文本排列方向 > 横排',
        placement: 'MenuBar',
        name: '横排',
    },
    {
        id: 1224,
        label: '文字 > 文本排列方向 > 竖排',
        placement: 'MenuBar',
        name: '竖排',
    },
    {
        id: 1228,
        label: '文字 > 创建工作路径',
        placement: 'MenuBar',
        name: '创建工作路径',
    },
    {
        id: 1229,
        label: '文字 > 转换为形状',
        placement: 'MenuBar',
        name: '转换为形状',
    },
    {
        id: 1231,
        label: '图层 > 对齐 > 顶边',
        placement: 'MenuBar',
        name: '顶边',
    },
    {
        id: 1232,
        label: '图层 > 对齐 > 底边',
        placement: 'MenuBar',
        name: '底边',
    },
    {
        id: 1233,
        label: '图层 > 对齐 > 垂直居中',
        placement: 'MenuBar',
        name: '垂直居中',
    },
    {
        id: 1234,
        label: '图层 > 对齐 > 左边',
        placement: 'MenuBar',
        name: '左边',
    },
    {
        id: 1235,
        label: '图层 > 对齐 > 右边',
        placement: 'MenuBar',
        name: '右边',
    },
    {
        id: 1236,
        label: '图层 > 对齐 > 水平居中',
        placement: 'MenuBar',
        name: '水平居中',
    },
    {
        id: 1237,
        label: '编辑 > 自动对齐图层...',
        placement: 'MenuBar',
        name: '自动对齐图层...',
    },
    {
        id: 1238,
        label: '编辑 > 自动混合图层...',
        placement: 'MenuBar',
        name: '自动混合图层...',
    },
    {
        id: 1239,
        label: '图层 > 分布 > 垂直',
        placement: 'MenuBar',
        name: '垂直',
    },
    {
        id: 1241,
        label: '图层 > 分布 > 顶边',
        placement: 'MenuBar',
        name: '顶边',
    },
    {
        id: 1242,
        label: '图层 > 分布 > 底边',
        placement: 'MenuBar',
        name: '底边',
    },
    {
        id: 1243,
        label: '图层 > 分布 > 垂直居中',
        placement: 'MenuBar',
        name: '垂直居中',
    },
    {
        id: 1245,
        label: '图层 > 分布 > 左边',
        placement: 'MenuBar',
        name: '左边',
    },
    {
        id: 1246,
        label: '图层 > 分布 > 右边',
        placement: 'MenuBar',
        name: '右边',
    },
    {
        id: 1247,
        label: '图层 > 分布 > 水平居中',
        placement: 'MenuBar',
        name: '水平居中',
    },
    {
        id: 1249,
        label: '图层 > 分布 > 水平',
        placement: 'MenuBar',
        name: '水平',
    },
    {
        id: 1281,
        label: '选择 > 存储选区...',
        placement: 'MenuBar',
        name: '存储选区...',
    },
    {
        id: 1284,
        label: '视图 > 水平翻转',
        placement: 'MenuBar',
        name: '水平翻转',
    },
    {
        id: 1285,
        label: '视图 > 图案预览',
        placement: 'MenuBar',
        name: '图案预览',
    },
    {
        id: 1292,
        label: '图层 > 图层蒙版 > 从透明区域',
        placement: 'MenuBar',
        name: '从透明区域',
    },
    {
        id: 1295,
        label: '图层 > 修边 > 颜色净化...',
        placement: 'MenuBar',
        name: '颜色净化...',
    },
    {
        id: 1297,
        label: '编辑 > 选择性粘贴 > 原位粘贴',
        placement: 'MenuBar',
        name: '原位粘贴',
    },
    {
        id: 1299,
        label: '视图 > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: '图层 > 图层样式 > 投影...',
        placement: 'MenuBar',
        name: '投影...',
    },
    {
        id: 1302,
        label: '图层 > 图层样式 > 内阴影...',
        placement: 'MenuBar',
        name: '内阴影...',
    },
    {
        id: 1303,
        label: '图层 > 图层样式 > 外发光...',
        placement: 'MenuBar',
        name: '外发光...',
    },
    {
        id: 1304,
        label: '图层 > 图层样式 > 内发光...',
        placement: 'MenuBar',
        name: '内发光...',
    },
    {
        id: 1305,
        label: '图层 > 图层样式 > 斜面和浮雕...',
        placement: 'MenuBar',
        name: '斜面和浮雕...',
    },
    {
        id: 1306,
        label: '图层 > 图层样式 > 隐藏所有效果',
        placement: 'MenuBar',
        name: '隐藏所有效果',
    },
    {
        id: 1307,
        label: '图层 > 图层样式 > 全局光...',
        placement: 'MenuBar',
        name: '全局光...',
    },
    {
        id: 1308,
        label: '图层 > 图层样式 > 创建图层',
        placement: 'MenuBar',
        name: '创建图层',
    },
    {
        id: 1312,
        label: '图层 > 图层样式 > 光泽...',
        placement: 'MenuBar',
        name: '光泽...',
    },
    {
        id: 1313,
        label: '图层 > 图层样式 > 描边...',
        placement: 'MenuBar',
        name: '描边...',
    },
    {
        id: 1314,
        label: '图层 > 图层样式 > 拷贝图层样式',
        placement: 'MenuBar',
        name: '拷贝图层样式',
    },
    {
        id: 1315,
        label: '图层 > 图层样式 > 粘贴图层样式',
        placement: 'MenuBar',
        name: '粘贴图层样式',
    },
    {
        id: 1327,
        label: '图层 > 图层样式 > 缩放效果...',
        placement: 'MenuBar',
        name: '缩放效果...',
    },
    {
        id: 1331,
        label: '图层 > 图层样式 > 混合选项...',
        placement: 'MenuBar',
        name: '混合选项...',
    },
    {
        id: 1335,
        label: '图层 > 图层样式 > 颜色叠加...',
        placement: 'MenuBar',
        name: '颜色叠加...',
    },
    {
        id: 1336,
        label: '图层 > 图层样式 > 渐变叠加...',
        placement: 'MenuBar',
        name: '渐变叠加...',
    },
    {
        id: 1337,
        label: '图层 > 图层样式 > 图案叠加...',
        placement: 'MenuBar',
        name: '图案叠加...',
    },
    {
        id: 1339,
        label: '图层 > 图层样式 > 清除图层样式',
        placement: 'MenuBar',
        name: '清除图层样式',
    },
    {
        id: 1355,
        label: '窗口 > 注释',
        placement: 'MenuBar',
        name: '注释',
    },
    {
        id: 1382,
        label: '窗口 > 直方图',
        placement: 'MenuBar',
        name: '直方图',
    },
    {
        id: 1396,
        label: '窗口 > 画笔',
        placement: 'MenuBar',
        name: '画笔',
    },
    {
        id: 1429,
        label: '增效工具 > 增效工具面板',
        placement: 'MenuBar',
        name: '增效工具面板',
    },
    {
        id: 1430,
        label: '增效工具 > 浏览增效工具...',
        placement: 'MenuBar',
        name: '浏览增效工具...',
    },
    {
        id: 1431,
        label: '增效工具 > 管理增效工具...',
        placement: 'MenuBar',
        name: '管理增效工具...',
    },
    {
        id: 1460,
        label: '选择 > 焦点区域...',
        placement: 'MenuBar',
        name: '焦点区域...',
    },
    {
        id: 1461,
        label: '选择 > 主体',
        placement: 'MenuBar',
        name: '主体',
    },
    {
        id: 1462,
        label: '选择 > 天空',
        placement: 'MenuBar',
        name: '天空',
    },
    {
        id: 1502,
        label: '文件 > 导入 > 来自设备的图像...',
        placement: 'MenuBar',
        name: '来自设备的图像...',
    },
    {
        id: 1503,
        label: '文件 > 从 iPhone 或 iPad 导入',
        placement: 'MenuBar',
        name: '从 iPhone 或 iPad 导入',
    },
    {
        id: 1510,
        label: '编辑 > 内容识别填充...',
        placement: 'MenuBar',
        name: '内容识别填充...',
    },
    {
        id: 1520,
        label: '文件 > 在 Bridge 中浏览...',
        placement: 'MenuBar',
        name: '在 Bridge 中浏览...',
    },
    {
        id: 1522,
        label: '文字 > 来自 Adobe Fonts 的更多字体...',
        placement: 'MenuBar',
        name: '来自 Adobe Fonts 的更多字体...',
    },
    {
        id: 1530,
        label: '文件 > 关闭并转到 Bridge...',
        placement: 'MenuBar',
        name: '关闭并转到 Bridge...',
    },
    {
        id: 1613,
        label: '编辑 > 远程连接...',
        placement: 'MenuBar',
        name: '远程连接...',
    },
    {
        id: 1676,
        label: '文件 > 脚本 > 浏览...',
        placement: 'MenuBar',
        name: '浏览...',
    },
    {
        id: 1695,
        label: '文件 > 导出 > 存储为 Web 所用格式（旧版）...',
        placement: 'MenuBar',
        name: '存储为 Web 所用格式（旧版）...',
    },
    {
        id: 1696,
        label: '文件 > 自动 > PDF 演示文稿...',
        placement: 'MenuBar',
        name: 'PDF 演示文稿...',
    },
    {
        id: 1701,
        label: '图像 > 调整 > 反相',
        placement: 'MenuBar',
        name: '反相',
    },
    {
        id: 1702,
        label: '图像 > 调整 > 色调均化',
        placement: 'MenuBar',
        name: '色调均化',
    },
    {
        id: 1703,
        label: '图像 > 调整 > 阈值...',
        placement: 'MenuBar',
        name: '阈值...',
    },
    {
        id: 1704,
        label: '图像 > 调整 > 色调分离...',
        placement: 'MenuBar',
        name: '色调分离...',
    },
    {
        id: 1750,
        label: '编辑 > 生成式填充...',
        placement: 'MenuBar',
        name: '生成式填充...',
    },
    {
        id: 1771,
        label: '编辑 > 生成图像...',
        placement: 'MenuBar',
        name: '生成图像...',
    },
    {
        id: 1801,
        label: '图像 > 调整 > 色阶...',
        placement: 'MenuBar',
        name: '色阶...',
    },
    {
        id: 1802,
        label: '图像 > 调整 > 曲线...',
        placement: 'MenuBar',
        name: '曲线...',
    },
    {
        id: 1803,
        label: '图像 > 调整 > 亮度/对比度...',
        placement: 'MenuBar',
        name: '亮度/对比度...',
    },
    {
        id: 1804,
        label: '图像 > 调整 > 色彩平衡...',
        placement: 'MenuBar',
        name: '色彩平衡...',
    },
    {
        id: 1805,
        label: '图像 > 调整 > 色相/饱和度...',
        placement: 'MenuBar',
        name: '色相/饱和度...',
    },
    {
        id: 1806,
        label: '图像 > 调整 > 替换颜色...',
        placement: 'MenuBar',
        name: '替换颜色...',
    },
    {
        id: 1807,
        label: '图像 > 调整 > 可选颜色...',
        placement: 'MenuBar',
        name: '可选颜色...',
    },
    {
        id: 1808,
        label: '图像 > 自动色调',
        placement: 'MenuBar',
        name: '自动色调',
    },
    {
        id: 1809,
        label: '图像 > 调整 > 去色',
        placement: 'MenuBar',
        name: '去色',
    },
    {
        id: 1810,
        label: '图像 > 自动对比度',
        placement: 'MenuBar',
        name: '自动对比度',
    },
    {
        id: 1817,
        label: '图像 > 自动颜色',
        placement: 'MenuBar',
        name: '自动颜色',
    },
    {
        id: 1822,
        label: '图像 > 调整 > 匹配颜色...',
        placement: 'MenuBar',
        name: '匹配颜色...',
    },
    {
        id: 1824,
        label: '图像 > 调整 > 黑白...',
        placement: 'MenuBar',
        name: '黑白...',
    },
    {
        id: 1827,
        label: '图像 > 调整 > 自然饱和度...',
        placement: 'MenuBar',
        name: '自然饱和度...',
    },
    {
        id: 1900,
        label: '图像 > 计算...',
        placement: 'MenuBar',
        name: '计算...',
    },
    {
        id: 1942,
        label: '图层 > 新建 > 背景',
        placement: 'MenuBar',
        name: '背景',
    },
    {
        id: 1943,
        label: '选择 > 重新选择',
        placement: 'MenuBar',
        name: '重新选择',
    },
    {
        id: 1953,
        label: '图层 > 矢量蒙版 > 隐藏全部',
        placement: 'MenuBar',
        name: '隐藏全部',
    },
    {
        id: 1954,
        label: '图层 > 矢量蒙版 > 显示全部',
        placement: 'MenuBar',
        name: '显示全部',
    },
    {
        id: 1955,
        label: '图层 > 矢量蒙版 > 当前路径',
        placement: 'MenuBar',
        name: '当前路径',
    },
    {
        id: 1956,
        label: '图层 > 矢量蒙版 > 删除',
        placement: 'MenuBar',
        name: '删除',
    },
    {
        id: 1957,
        label: '图层 > 栅格化 > 矢量蒙版',
        placement: 'MenuBar',
        name: '矢量蒙版',
    },
    {
        id: 1959,
        label: '图层 > 矢量蒙版 > 启用(B)',
        placement: 'MenuBar',
        name: '启用(B)',
    },
    {
        id: 1971,
        label: '选择 > 变换选区',
        placement: 'MenuBar',
        name: '变换选区',
    },
    {
        id: 2101,
        label: '文件 > 打印...',
        placement: 'MenuBar',
        name: '打印...',
    },
    {
        id: 2109,
        label: '图层 > 矢量蒙版 > 链接',
        placement: 'MenuBar',
        name: '链接',
    },
    {
        id: 2201,
        label: '编辑 > 变换 > 缩放',
        placement: 'MenuBar',
        name: '缩放',
    },
    {
        id: 2202,
        label: '编辑 > 变换 > 斜切',
        placement: 'MenuBar',
        name: '斜切',
    },
    {
        id: 2203,
        label: '编辑 > 变换 > 透视',
        placement: 'MenuBar',
        name: '透视',
    },
    {
        id: 2204,
        label: '编辑 > 变换 > 扭曲',
        placement: 'MenuBar',
        name: '扭曲',
    },
    {
        id: 2205,
        label: '编辑 > 变换 > 旋转',
        placement: 'MenuBar',
        name: '旋转',
    },
    {
        id: 2207,
        label: '编辑 > 自由变换',
        placement: 'MenuBar',
        name: '自由变换',
    },
    {
        id: 2208,
        label: '编辑 > 变换 > 旋转 180 度',
        placement: 'MenuBar',
        name: '旋转 180 度',
    },
    {
        id: 2209,
        label: '编辑 > 变换 > 顺时针旋转 90 度',
        placement: 'MenuBar',
        name: '顺时针旋转 90 度',
    },
    {
        id: 2210,
        label: '编辑 > 变换 > 逆时针旋转 90 度',
        placement: 'MenuBar',
        name: '逆时针旋转 90 度',
    },
    {
        id: 2211,
        label: '编辑 > 变换 > 水平翻转',
        placement: 'MenuBar',
        name: '水平翻转',
    },
    {
        id: 2212,
        label: '编辑 > 变换 > 垂直翻转',
        placement: 'MenuBar',
        name: '垂直翻转',
    },
    {
        id: 2217,
        label: '编辑 > 变换 > 再次',
        placement: 'MenuBar',
        name: '再次',
    },
    {
        id: 2218,
        label: '文字 > 文字变形...',
        placement: 'MenuBar',
        name: '文字变形...',
    },
    {
        id: 2219,
        label: '编辑 > 变换 > 变形',
        placement: 'MenuBar',
        name: '变形',
    },
    {
        id: 2220,
        label: '编辑 > 内容识别缩放',
        placement: 'MenuBar',
        name: '内容识别缩放',
    },
    {
        id: 2221,
        label: '编辑 > 操控变形',
        placement: 'MenuBar',
        name: '操控变形',
    },
    {
        id: 2224,
        label: '滤镜 > 模糊画廊 > 光圈模糊...',
        placement: 'MenuBar',
        name: '光圈模糊...',
    },
    {
        id: 2225,
        label: '滤镜 > 模糊画廊 > 场景模糊...',
        placement: 'MenuBar',
        name: '场景模糊...',
    },
    {
        id: 2226,
        label: '滤镜 > 模糊画廊 > 移轴模糊...',
        placement: 'MenuBar',
        name: '移轴模糊...',
    },
    {
        id: 2227,
        label: '滤镜 > 模糊画廊 > 路径模糊...',
        placement: 'MenuBar',
        name: '路径模糊...',
    },
    {
        id: 2229,
        label: '滤镜 > 模糊画廊 > 旋转模糊...',
        placement: 'MenuBar',
        name: '旋转模糊...',
    },
    {
        id: 2231,
        label: '滤镜 > 渲染 > 火焰...',
        placement: 'MenuBar',
        name: '火焰...',
    },
    {
        id: 2232,
        label: '滤镜 > 渲染 > 图片框...',
        placement: 'MenuBar',
        name: '图片框...',
    },
    {
        id: 2233,
        label: '滤镜 > 渲染 > 树...',
        placement: 'MenuBar',
        name: '树...',
    },
    {
        id: 2250,
        label: '编辑 > 变换 > 水平拆分变形',
        placement: 'MenuBar',
        name: '水平拆分变形',
    },
    {
        id: 2251,
        label: '编辑 > 变换 > 垂直拆分变形',
        placement: 'MenuBar',
        name: '垂直拆分变形',
    },
    {
        id: 2252,
        label: '编辑 > 变换 > 交叉拆分变形',
        placement: 'MenuBar',
        name: '交叉拆分变形',
    },
    {
        id: 2253,
        label: '编辑 > 变换 > 移去变形拆分',
        placement: 'MenuBar',
        name: '移去变形拆分',
    },
    {
        id: 2254,
        label: '编辑 > 变换 > 切换参考线',
        placement: 'MenuBar',
        name: '切换参考线',
    },
    {
        id: 2255,
        label: '编辑 > 变换 > 转换变形锚点',
        placement: 'MenuBar',
        name: '转换变形锚点',
    },
    {
        id: 2260,
        label: '编辑 > 天空替换...',
        placement: 'MenuBar',
        name: '天空替换...',
    },
    {
        id: 2304,
        label: 'Photoshop > 首选项 > 性能...',
        placement: 'MenuBar',
        name: '性能...',
    },
    {
        id: 2311,
        label: 'Photoshop > 首选项 > 常规...',
        placement: 'MenuBar',
        name: '常规...',
    },
    {
        id: 2312,
        label: 'Photoshop > 首选项 > 光标...',
        placement: 'MenuBar',
        name: '光标...',
    },
    {
        id: 2313,
        label: 'Photoshop > 首选项 > 透明度与色域...',
        placement: 'MenuBar',
        name: '透明度与色域...',
    },
    {
        id: 2314,
        label: 'Photoshop > 首选项 > 单位与标尺...',
        placement: 'MenuBar',
        name: '单位与标尺...',
    },
    {
        id: 2315,
        label: 'Photoshop > 首选项 > 参考线、网格和切片...',
        placement: 'MenuBar',
        name: '参考线、网格和切片...',
    },
    {
        id: 2316,
        label: 'Photoshop > 首选项 > 增效工具...',
        placement: 'MenuBar',
        name: '增效工具...',
    },
    {
        id: 2317,
        label: 'Photoshop > 首选项 > 文件处理...',
        placement: 'MenuBar',
        name: '文件处理...',
    },
    {
        id: 2322,
        label: 'Photoshop > 首选项 > 文字...',
        placement: 'MenuBar',
        name: '文字...',
    },
    {
        id: 2323,
        label: 'Photoshop > 首选项 > 界面...',
        placement: 'MenuBar',
        name: '界面...',
    },
    {
        id: 2324,
        label: 'Photoshop > 首选项 > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > 首选项 > 技术预览...',
        placement: 'MenuBar',
        name: '技术预览...',
    },
    {
        id: 2328,
        label: 'Photoshop > 首选项 > 暂存盘...',
        placement: 'MenuBar',
        name: '暂存盘...',
    },
    {
        id: 2329,
        label: 'Photoshop > 首选项 > 历史记录和 Content Credentials(H)...',
        placement: 'MenuBar',
        name: '历史记录和 Content Credentials(H)...',
    },
    {
        id: 2330,
        label: 'Photoshop > 首选项 > 工具...',
        placement: 'MenuBar',
        name: '工具...',
    },
    {
        id: 2331,
        label: 'Photoshop > 首选项 > 工作区...',
        placement: 'MenuBar',
        name: '工作区...',
    },
    {
        id: 2332,
        label: 'Photoshop > 首选项 > 导出...',
        placement: 'MenuBar',
        name: '导出...',
    },
    {
        id: 2332,
        label: '文件 > 导出 > 导出首选项...',
        placement: 'MenuBar',
        name: '导出首选项...',
    },
    {
        id: 2333,
        label: 'Photoshop > 首选项 > 增强型控件...',
        placement: 'MenuBar',
        name: '增强型控件...',
    },
    {
        id: 2335,
        label: 'Photoshop > 首选项 > 图像处理...',
        placement: 'MenuBar',
        name: '图像处理...',
    },
    {
        id: 2344,
        label: '编辑 > 颜色设置...',
        placement: 'MenuBar',
        name: '颜色设置...',
    },
    {
        id: 2345,
        label: '编辑 > OpenColorIO 设置...',
        placement: 'MenuBar',
        name: 'OpenColorIO 设置...',
    },
    {
        id: 2361,
        label: '编辑 > 清理 > 历史记录',
        placement: 'MenuBar',
        name: '历史记录',
    },
    {
        id: 2701,
        label: '图层 > 修边 > 移去黑色杂边',
        placement: 'MenuBar',
        name: '移去黑色杂边',
    },
    {
        id: 2703,
        label: '图层 > 修边 > 移去白色杂边',
        placement: 'MenuBar',
        name: '移去白色杂边',
    },
    {
        id: 2711,
        label: '图层 > 排列 > 置为顶层',
        placement: 'MenuBar',
        name: '置为顶层',
    },
    {
        id: 2712,
        label: '图层 > 排列 > 前移一层',
        placement: 'MenuBar',
        name: '前移一层',
    },
    {
        id: 2713,
        label: '图层 > 排列 > 后移一层',
        placement: 'MenuBar',
        name: '后移一层',
    },
    {
        id: 2714,
        label: '图层 > 排列 > 置为底层',
        placement: 'MenuBar',
        name: '置为底层',
    },
    {
        id: 2715,
        label: '图层 > 排列 > 反向',
        placement: 'MenuBar',
        name: '反向',
    },
    {
        id: 2769,
        label: '图层 > 智能滤镜 > 停用智能滤镜',
        placement: 'MenuBar',
        name: '停用智能滤镜',
    },
    {
        id: 2770,
        label: '图层 > 智能滤镜 > 清除智能滤镜',
        placement: 'MenuBar',
        name: '清除智能滤镜',
    },
    {
        id: 2802,
        label: '视图 > 校样设置 > 自定...',
        placement: 'MenuBar',
        name: '自定...',
    },
    {
        id: 2803,
        label: '视图 > 校样设置 > 工作中的 CMYK',
        placement: 'MenuBar',
        name: '工作中的 CMYK',
    },
    {
        id: 2804,
        label: '视图 > 校样设置 > 工作中的青版',
        placement: 'MenuBar',
        name: '工作中的青版',
    },
    {
        id: 2805,
        label: '视图 > 校样设置 > 工作中的洋红版',
        placement: 'MenuBar',
        name: '工作中的洋红版',
    },
    {
        id: 2806,
        label: '视图 > 校样设置 > 工作中的黄版',
        placement: 'MenuBar',
        name: '工作中的黄版',
    },
    {
        id: 2807,
        label: '视图 > 校样设置 > 工作中的黑版',
        placement: 'MenuBar',
        name: '工作中的黑版',
    },
    {
        id: 2808,
        label: '视图 > 校样设置 > 工作中的 CMY 版',
        placement: 'MenuBar',
        name: '工作中的 CMY 版',
    },
    {
        id: 2809,
        label: '视图 > 校样设置 > 旧版 Macintosh RGB (Gamma 1.8)',
        placement: 'MenuBar',
        name: '旧版 Macintosh RGB (Gamma 1.8)',
    },
    {
        id: 2810,
        label: '视图 > 校样设置 > Internet 标准 RGB (sRGB)',
        placement: 'MenuBar',
        name: 'Internet 标准 RGB (sRGB)',
    },
    {
        id: 2811,
        label: '视图 > 校样设置 > 显示器 RGB',
        placement: 'MenuBar',
        name: '显示器 RGB',
    },
    {
        id: 2815,
        label: '视图 > 校样设置 > 色盲 - 红色盲型',
        placement: 'MenuBar',
        name: '色盲 - 红色盲型',
    },
    {
        id: 2816,
        label: '视图 > 校样设置 > 色盲 - 绿色盲型',
        placement: 'MenuBar',
        name: '色盲 - 绿色盲型',
    },
    {
        id: 2820,
        label: '图像 > 分析 > 标尺工具',
        placement: 'MenuBar',
        name: '标尺工具',
    },
    {
        id: 2830,
        label: '图像 > 分析 > 置入比例标记...',
        placement: 'MenuBar',
        name: '置入比例标记...',
    },
    {
        id: 2841,
        label: '图像 > 分析 > 设置测量比例 > 默认值(D)',
        placement: 'MenuBar',
        name: '默认值(D)',
    },
    {
        id: 2842,
        label: '图像 > 分析 > 设置测量比例 > 自定(C)...',
        placement: 'MenuBar',
        name: '自定(C)...',
    },
    {
        id: 2851,
        label: '图像 > 分析 > 选择数据点 > 自定(C)...',
        placement: 'MenuBar',
        name: '自定(C)...',
    },
    {
        id: 2860,
        label: '图像 > 分析 > 记录测量',
        placement: 'MenuBar',
        name: '记录测量',
    },
    {
        id: 2880,
        label: '窗口 > 测量记录',
        placement: 'MenuBar',
        name: '测量记录',
    },
    {
        id: 2912,
        label: '编辑 > 清理 > 剪贴板',
        placement: 'MenuBar',
        name: '剪贴板',
    },
    {
        id: 2915,
        label: '编辑 > 清理 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 2920,
        label: '编辑 > 清理 > 视频高速缓存',
        placement: 'MenuBar',
        name: '视频高速缓存',
    },
    {
        id: 2939,
        label: '窗口 > 工作区 > 锁定工作区(L)',
        placement: 'MenuBar',
        name: '锁定工作区(L)',
    },
    {
        id: 2940,
        label: '视图 > 参考线 > 锁定参考线',
        placement: 'MenuBar',
        name: '锁定参考线',
    },
    {
        id: 2950,
        label: '视图 > 参考线 > 清除参考线',
        placement: 'MenuBar',
        name: '清除参考线',
    },
    {
        id: 2951,
        label: '图层 > 删除 > 隐藏图层',
        placement: 'MenuBar',
        name: '隐藏图层',
    },
    {
        id: 2952,
        label: '视图 > 参考线 > 清除所选画板参考线',
        placement: 'MenuBar',
        name: '清除所选画板参考线',
    },
    {
        id: 2953,
        label: '视图 > 参考线 > 清除画布参考线',
        placement: 'MenuBar',
        name: '清除画布参考线',
    },
    {
        id: 2956,
        label: '图层 > 新建 > 从图层建立组...',
        placement: 'MenuBar',
        name: '从图层建立组...',
    },
    {
        id: 2957,
        label: '图层 > 锁定图层...',
        placement: 'MenuBar',
        name: '锁定图层...',
    },
    {
        id: 2958,
        label: '图层 > 图层编组',
        placement: 'MenuBar',
        name: '图层编组',
    },
    {
        id: 2959,
        label: '图层 > 取消图层编组',
        placement: 'MenuBar',
        name: '取消图层编组',
    },
    {
        id: 2960,
        label: '图层 > 选择链接图层',
        placement: 'MenuBar',
        name: '选择链接图层',
    },
    {
        id: 2961,
        label: '图层 > 链接图层',
        placement: 'MenuBar',
        name: '链接图层',
    },
    {
        id: 2962,
        label: '选择 > 所有图层',
        placement: 'MenuBar',
        name: '所有图层',
    },
    {
        id: 2963,
        label: '选择 > 取消选择图层',
        placement: 'MenuBar',
        name: '取消选择图层',
    },
    {
        id: 2967,
        label: '视图 > 锁定切片',
        placement: 'MenuBar',
        name: '锁定切片',
    },
    {
        id: 2969,
        label: '视图 > 清除切片',
        placement: 'MenuBar',
        name: '清除切片',
    },
    {
        id: 2970,
        label: '图层 > 新建 > 通过拷贝的图层',
        placement: 'MenuBar',
        name: '通过拷贝的图层',
    },
    {
        id: 2971,
        label: '图层 > 新建 > 通过剪切的图层',
        placement: 'MenuBar',
        name: '通过剪切的图层',
    },
    {
        id: 2972,
        label: '图层 > 创建剪贴蒙版',
        placement: 'MenuBar',
        name: '创建剪贴蒙版',
    },
    {
        id: 2976,
        label: '图层 > 新建 > 组...',
        placement: 'MenuBar',
        name: '组...',
    },
    {
        id: 2980,
        label: '图层 > 智能对象 > 转换为智能对象',
        placement: 'MenuBar',
        name: '转换为智能对象',
    },
    {
        id: 2981,
        label: '图层 > 智能对象 > 通过拷贝新建智能对象',
        placement: 'MenuBar',
        name: '通过拷贝新建智能对象',
    },
    {
        id: 2982,
        label: '选择 > 查找图层',
        placement: 'MenuBar',
        name: '查找图层',
    },
    {
        id: 2983,
        label: '图层 > 重命名图层...',
        placement: 'MenuBar',
        name: '重命名图层...',
    },
    {
        id: 2986,
        label: '选择 > 隔离图层',
        placement: 'MenuBar',
        name: '隔离图层',
    },
    {
        id: 2991,
        label: '图像 > 图像旋转 > 顺时针 90 度',
        placement: 'MenuBar',
        name: '顺时针 90 度',
    },
    {
        id: 2992,
        label: '图像 > 图像旋转 > 逆时针 90 度',
        placement: 'MenuBar',
        name: '逆时针 90 度',
    },
    {
        id: 2993,
        label: '图像 > 图像旋转 > 180 度',
        placement: 'MenuBar',
        name: '180 度',
    },
    {
        id: 2994,
        label: '图像 > 图像旋转 > 任意角度...',
        placement: 'MenuBar',
        name: '任意角度...',
    },
    {
        id: 2996,
        label: '图像 > 图像旋转 > 水平翻转画布',
        placement: 'MenuBar',
        name: '水平翻转画布',
    },
    {
        id: 2997,
        label: '图像 > 图像旋转 > 垂直翻转画布',
        placement: 'MenuBar',
        name: '垂直翻转画布',
    },
    {
        id: 3056,
        label: '图像 > 调整 > 通道混合器...',
        placement: 'MenuBar',
        name: '通道混合器...',
    },
    {
        id: 3062,
        label: '图像 > 调整 > 渐变映射...',
        placement: 'MenuBar',
        name: '渐变映射...',
    },
    {
        id: 3063,
        label: '图像 > 调整 > 照片滤镜...',
        placement: 'MenuBar',
        name: '照片滤镜...',
    },
    {
        id: 3065,
        label: '图像 > 调整 > 阴影/高光...',
        placement: 'MenuBar',
        name: '阴影/高光...',
    },
    {
        id: 3066,
        label: '图像 > 调整 > 颜色查找...',
        placement: 'MenuBar',
        name: '颜色查找...',
    },
    {
        id: 3067,
        label: '图像 > 调整 > 曝光度...',
        placement: 'MenuBar',
        name: '曝光度...',
    },
    {
        id: 3076,
        label: '图层 > 智能滤镜 > 停用滤镜蒙版',
        placement: 'MenuBar',
        name: '停用滤镜蒙版',
    },
    {
        id: 3083,
        label: '图层 > 新建调整图层 > 曝光度...',
        placement: 'MenuBar',
        name: '曝光度...',
    },
    {
        id: 3085,
        label: '图层 > 新建调整图层 > 自然饱和度...',
        placement: 'MenuBar',
        name: '自然饱和度...',
    },
    {
        id: 3090,
        label: '文件 > 置入链接的智能对象...',
        placement: 'MenuBar',
        name: '置入链接的智能对象...',
    },
    {
        id: 3091,
        label: '图层 > 智能对象 > 在 Finder 中显示',
        placement: 'MenuBar',
        name: '在 Finder 中显示',
    },
    {
        id: 3092,
        label: '文件 > 打包…',
        placement: 'MenuBar',
        name: '打包…',
    },
    {
        id: 3098,
        label: '文件 > 自动 > 生成器插件',
        placement: 'MenuBar',
        name: '生成器插件',
    },
    {
        id: 3187,
        label: '窗口 > 样式',
        placement: 'MenuBar',
        name: '样式',
    },
    {
        id: 3300,
        label: '文字 > 面板 > 字符面板',
        placement: 'MenuBar',
        name: '字符面板',
    },
    {
        id: 3300,
        label: '窗口 > 字符',
        placement: 'MenuBar',
        name: '字符',
    },
    {
        id: 3309,
        label: '文字 > OpenType > 标准连字',
        placement: 'MenuBar',
        name: '标准连字',
    },
    {
        id: 3310,
        label: '文字 > OpenType > 旧样式',
        placement: 'MenuBar',
        name: '旧样式',
    },
    {
        id: 3327,
        label: '文字 > OpenType > 等比公制字',
        placement: 'MenuBar',
        name: '等比公制字',
    },
    {
        id: 3334,
        label: '文字 > OpenType > 花饰字',
        placement: 'MenuBar',
        name: '花饰字',
    },
    {
        id: 3338,
        label: '文字 > OpenType > 上下文替代字',
        placement: 'MenuBar',
        name: '上下文替代字',
    },
    {
        id: 3339,
        label: '文字 > OpenType > 自由连字',
        placement: 'MenuBar',
        name: '自由连字',
    },
    {
        id: 3340,
        label: '文字 > OpenType > 文体替代字',
        placement: 'MenuBar',
        name: '文体替代字',
    },
    {
        id: 3341,
        label: '文字 > OpenType > 标题替代字',
        placement: 'MenuBar',
        name: '标题替代字',
    },
    {
        id: 3342,
        label: '文字 > OpenType > 装饰字',
        placement: 'MenuBar',
        name: '装饰字',
    },
    {
        id: 3343,
        label: '文字 > OpenType > 序数字',
        placement: 'MenuBar',
        name: '序数字',
    },
    {
        id: 3344,
        label: '文字 > OpenType > 分数字',
        placement: 'MenuBar',
        name: '分数字',
    },
    {
        id: 3345,
        label: '文字 > OpenType > 日语 78',
        placement: 'MenuBar',
        name: '日语 78',
    },
    {
        id: 3346,
        label: '文字 > OpenType > 日语专家',
        placement: 'MenuBar',
        name: '日语专家',
    },
    {
        id: 3347,
        label: '文字 > OpenType > 传统日语',
        placement: 'MenuBar',
        name: '传统日语',
    },
    {
        id: 3348,
        label: '文字 > OpenType > 假名',
        placement: 'MenuBar',
        name: '假名',
    },
    {
        id: 3349,
        label: '文字 > OpenType > 罗马斜体字',
        placement: 'MenuBar',
        name: '罗马斜体字',
    },
    {
        id: 3350,
        label: '文字 > 面板 > 段落面板',
        placement: 'MenuBar',
        name: '段落面板',
    },
    {
        id: 3350,
        label: '窗口 > 段落',
        placement: 'MenuBar',
        name: '段落',
    },
    {
        id: 3370,
        label: '文字 > 消除锯齿 > 无',
        placement: 'MenuBar',
        name: '无',
    },
    {
        id: 3371,
        label: '文字 > 消除锯齿 > 犀利',
        placement: 'MenuBar',
        name: '犀利',
    },
    {
        id: 3372,
        label: '文字 > 消除锯齿 > 浑厚',
        placement: 'MenuBar',
        name: '浑厚',
    },
    {
        id: 3373,
        label: '文字 > 消除锯齿 > 平滑',
        placement: 'MenuBar',
        name: '平滑',
    },
    {
        id: 3374,
        label: '文字 > 消除锯齿 > 锐利',
        placement: 'MenuBar',
        name: '锐利',
    },
    {
        id: 3375,
        label: '文字 > 消除锯齿 > Mac LCD',
        placement: 'MenuBar',
        name: 'Mac LCD',
    },
    {
        id: 3376,
        label: '文字 > 消除锯齿 > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: '文字 > 转换文本形状类型',
        placement: 'MenuBar',
        name: '转换文本形状类型',
    },
    {
        id: 3390,
        label: '文字 > 更新所有文字图层',
        placement: 'MenuBar',
        name: '更新所有文字图层',
    },
    {
        id: 3392,
        label: '编辑 > 拼写检查...',
        placement: 'MenuBar',
        name: '拼写检查...',
    },
    {
        id: 3393,
        label: '编辑 > 查找和替换文本...',
        placement: 'MenuBar',
        name: '查找和替换文本...',
    },
    {
        id: 3409,
        label: '图层 > 合并形状 > 统一形状',
        placement: 'MenuBar',
        name: '统一形状',
    },
    {
        id: 3410,
        label: '图层 > 合并形状 > 减去顶层形状',
        placement: 'MenuBar',
        name: '减去顶层形状',
    },
    {
        id: 3411,
        label: '图层 > 合并形状 > 统一重叠处形状',
        placement: 'MenuBar',
        name: '统一重叠处形状',
    },
    {
        id: 3412,
        label: '图层 > 合并形状 > 减去重叠处形状',
        placement: 'MenuBar',
        name: '减去重叠处形状',
    },
    {
        id: 3438,
        label: '图层 > 复制 SVG',
        placement: 'MenuBar',
        name: '复制 SVG',
    },
    {
        id: 3439,
        label: '图层 > 复制 CSS',
        placement: 'MenuBar',
        name: '复制 CSS',
    },
    {
        id: 3443,
        label: '文件 > 导出 > 导出为...',
        placement: 'MenuBar',
        name: '导出为...',
    },
    {
        id: 3444,
        label: '文件 > 导出 > 快速导出为 PNG',
        placement: 'MenuBar',
        name: '快速导出为 PNG',
    },
    {
        id: 3446,
        label: '图层 > 快速导出为 PNG',
        placement: 'MenuBar',
        name: '快速导出为 PNG',
    },
    {
        id: 3447,
        label: '图层 > 导出为...',
        placement: 'MenuBar',
        name: '导出为...',
    },
    {
        id: 3451,
        label: '文字 > 语言选项 > 阿拉伯语数字 (从左到右) - 123%',
        placement: 'MenuBar',
        name: '阿拉伯语数字 (从左到右) - 123%',
    },
    {
        id: 3452,
        label: '文字 > 语言选项 > 波斯语数字',
        placement: 'MenuBar',
        name: '波斯语数字',
    },
    {
        id: 3453,
        label: '文字 > 语言选项 > 印地语数字',
        placement: 'MenuBar',
        name: '印地语数字',
    },
    {
        id: 3459,
        label: '文字 > 语言选项 > 阿拉伯语数字 (从右到左) - %123',
        placement: 'MenuBar',
        name: '阿拉伯语数字 (从右到左) - %123',
    },
    {
        id: 3500,
        label: '视图 > 显示额外内容',
        placement: 'MenuBar',
        name: '显示额外内容',
    },
    {
        id: 3501,
        label: '视图 > 显示 > 选区边缘(S)',
        placement: 'MenuBar',
        name: '选区边缘(S)',
    },
    {
        id: 3502,
        label: '视图 > 显示 > 目标路径(P)',
        placement: 'MenuBar',
        name: '目标路径(P)',
    },
    {
        id: 3503,
        label: '视图 > 显示 > 参考线',
        placement: 'MenuBar',
        name: '参考线',
    },
    {
        id: 3504,
        label: '视图 > 显示 > 网格(G)',
        placement: 'MenuBar',
        name: '网格(G)',
    },
    {
        id: 3505,
        label: '视图 > 显示 > 切片(L)',
        placement: 'MenuBar',
        name: '切片(L)',
    },
    {
        id: 3506,
        label: '视图 > 显示 > 注释(O)',
        placement: 'MenuBar',
        name: '注释(O)',
    },
    {
        id: 3507,
        label: '视图 > 显示 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 3508,
        label: '视图 > 显示 > 无',
        placement: 'MenuBar',
        name: '无',
    },
    {
        id: 3510,
        label: '视图 > 显示 > 显示额外选项...',
        placement: 'MenuBar',
        name: '显示额外选项...',
    },
    {
        id: 3511,
        label: '视图 > 显示 > 智能参考线(M)',
        placement: 'MenuBar',
        name: '智能参考线(M)',
    },
    {
        id: 3512,
        label: '视图 > 显示 > 图层边缘(E)',
        placement: 'MenuBar',
        name: '图层边缘(E)',
    },
    {
        id: 3513,
        label: '视图 > 显示 > 数量(C)',
        placement: 'MenuBar',
        name: '数量(C)',
    },
    {
        id: 3514,
        label: '视图 > 显示 > 像素网格(X)',
        placement: 'MenuBar',
        name: '像素网格(X)',
    },
    {
        id: 3517,
        label: '视图 > 显示 > 网格(H)',
        placement: 'MenuBar',
        name: '网格(H)',
    },
    {
        id: 3520,
        label: '视图 > 对齐',
        placement: 'MenuBar',
        name: '对齐',
    },
    {
        id: 3521,
        label: '视图 > 对齐到 > 参考线',
        placement: 'MenuBar',
        name: '参考线',
    },
    {
        id: 3522,
        label: '视图 > 对齐到 > 网格',
        placement: 'MenuBar',
        name: '网格',
    },
    {
        id: 3523,
        label: '视图 > 对齐到 > 切片',
        placement: 'MenuBar',
        name: '切片',
    },
    {
        id: 3524,
        label: '视图 > 对齐到 > 文档边界',
        placement: 'MenuBar',
        name: '文档边界',
    },
    {
        id: 3527,
        label: '视图 > 对齐到 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 3528,
        label: '视图 > 对齐到 > 无',
        placement: 'MenuBar',
        name: '无',
    },
    {
        id: 3530,
        label: '视图 > 对齐到 > 图层',
        placement: 'MenuBar',
        name: '图层',
    },
    {
        id: 3532,
        label: '视图 > 显示 > 图案预览拼贴边界',
        placement: 'MenuBar',
        name: '图案预览拼贴边界',
    },
    {
        id: 3533,
        label: '视图 > 显示 > 画板参考线',
        placement: 'MenuBar',
        name: '画板参考线',
    },
    {
        id: 3535,
        label: '视图 > 显示 > 画板名称',
        placement: 'MenuBar',
        name: '画板名称',
    },
    {
        id: 3536,
        label: '视图 > 显示 > 画布参考线',
        placement: 'MenuBar',
        name: '画布参考线',
    },
    {
        id: 3541,
        label: '图层 > 栅格化 > 形状',
        placement: 'MenuBar',
        name: '形状',
    },
    {
        id: 3542,
        label: '图层 > 栅格化 > 文字',
        placement: 'MenuBar',
        name: '文字',
    },
    {
        id: 3542,
        label: '文字 > 栅格化文字图层',
        placement: 'MenuBar',
        name: '栅格化文字图层',
    },
    {
        id: 3544,
        label: '图层 > 栅格化 > 填充内容',
        placement: 'MenuBar',
        name: '填充内容',
    },
    {
        id: 3545,
        label: '图层 > 栅格化 > 所有图层',
        placement: 'MenuBar',
        name: '所有图层',
    },
    {
        id: 3547,
        label: '图层 > 栅格化 > 图层',
        placement: 'MenuBar',
        name: '图层',
    },
    {
        id: 3549,
        label: '图层 > 智能对象 > 栅格化',
        placement: 'MenuBar',
        name: '栅格化',
    },
    {
        id: 3549,
        label: '图层 > 栅格化 > 智能对象',
        placement: 'MenuBar',
        name: '智能对象',
    },
    {
        id: 3551,
        label: '图层 > 栅格化 > 视频',
        placement: 'MenuBar',
        name: '视频',
    },
    {
        id: 3553,
        label: '图层 > 栅格化 > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: '图层 > 视频图层 > 栅格化',
        placement: 'MenuBar',
        name: '栅格化',
    },
    {
        id: 3557,
        label: '图层 > 栅格化 > 图层样式',
        placement: 'MenuBar',
        name: '图层样式',
    },
    {
        id: 3561,
        label: '图层 > 栅格化 > 生成式',
        placement: 'MenuBar',
        name: '生成式',
    },
    {
        id: 3585,
        label: '视图 > 显示 > 编辑图钉',
        placement: 'MenuBar',
        name: '编辑图钉',
    },
    {
        id: 4002,
        label: '帮助 > 更新...',
        placement: 'MenuBar',
        name: '更新...',
    },
    {
        id: 4210,
        label: '窗口 > 工具预设',
        placement: 'MenuBar',
        name: '工具预设',
    },
    {
        id: 5059,
        label: '图层 > 图层蒙版 > 删除',
        placement: 'MenuBar',
        name: '删除',
    },
    {
        id: 5068,
        label: '编辑 > 选择性粘贴 > 外部粘贴',
        placement: 'MenuBar',
        name: '外部粘贴',
    },
    {
        id: 5069,
        label: '选择 > 在快速蒙版模式下编辑',
        placement: 'MenuBar',
        name: '在快速蒙版模式下编辑',
    },
    {
        id: 5085,
        label: '图层 > 图层蒙版 > 链接',
        placement: 'MenuBar',
        name: '链接',
    },
    {
        id: 5095,
        label: '图层 > 图层蒙版 > 应用',
        placement: 'MenuBar',
        name: '应用',
    },
    {
        id: 5115,
        label: '窗口 > 工作区 > 新建工作区(N)...',
        placement: 'MenuBar',
        name: '新建工作区(N)...',
    },
    {
        id: 5116,
        label: '窗口 > 工作区 > 删除工作区(D)...',
        placement: 'MenuBar',
        name: '删除工作区(D)...',
    },
    {
        id: 5117,
        label: '窗口 > 工作区 > 复位基本功能(R)',
        placement: 'MenuBar',
        name: '复位基本功能(R)',
    },
    {
        id: 5217,
        label: '图层 > 新建基于图层的切片',
        placement: 'MenuBar',
        name: '新建基于图层的切片',
    },
    {
        id: 5226,
        label: '图层 > 智能滤镜 > 删除滤镜蒙版',
        placement: 'MenuBar',
        name: '删除滤镜蒙版',
    },
    {
        id: 5613,
        label: '视图 > 参考线 > 新建参考线...',
        placement: 'MenuBar',
        name: '新建参考线...',
    },
    {
        id: 5614,
        label: '视图 > 参考线 > 新建参考线版面...',
        placement: 'MenuBar',
        name: '新建参考线版面...',
    },
    {
        id: 5615,
        label: '视图 > 参考线 > 通过形状新建参考线',
        placement: 'MenuBar',
        name: '通过形状新建参考线',
    },
    {
        id: 5624,
        label: '编辑 > 定义自定形状...',
        placement: 'MenuBar',
        name: '定义自定形状...',
    },
    {
        id: 5634,
        label: '窗口 > 工作区 > 基本功能（默认）(E)',
        placement: 'MenuBar',
        name: '基本功能（默认）(E)',
    },
    {
        id: 5929,
        label: '窗口 > 排列 > 全部置于顶层',
        placement: 'MenuBar',
        name: '全部置于顶层',
    },
    {
        id: 5930,
        label: '窗口 > 排列 > 层叠',
        placement: 'MenuBar',
        name: '层叠',
    },
    {
        id: 5931,
        label: '窗口 > 排列 > 平铺',
        placement: 'MenuBar',
        name: '平铺',
    },
    {
        id: 5932,
        label: '窗口 > 排列 > 最小化',
        placement: 'MenuBar',
        name: '最小化',
    },
    {
        id: 5933,
        label: '窗口 > 排列 > 全部垂直拼贴',
        placement: 'MenuBar',
        name: '全部垂直拼贴',
    },
    {
        id: 5934,
        label: '窗口 > 排列 > 全部水平拼贴',
        placement: 'MenuBar',
        name: '全部水平拼贴',
    },
    {
        id: 5935,
        label: '窗口 > 排列 > 双联水平',
        placement: 'MenuBar',
        name: '双联水平',
    },
    {
        id: 5936,
        label: '窗口 > 排列 > 双联垂直',
        placement: 'MenuBar',
        name: '双联垂直',
    },
    {
        id: 5937,
        label: '窗口 > 排列 > 三联水平',
        placement: 'MenuBar',
        name: '三联水平',
    },
    {
        id: 5938,
        label: '窗口 > 排列 > 三联垂直',
        placement: 'MenuBar',
        name: '三联垂直',
    },
    {
        id: 5939,
        label: '窗口 > 排列 > 三联堆积',
        placement: 'MenuBar',
        name: '三联堆积',
    },
    {
        id: 5940,
        label: '窗口 > 排列 > 四联',
        placement: 'MenuBar',
        name: '四联',
    },
    {
        id: 5941,
        label: '窗口 > 排列 > 六联',
        placement: 'MenuBar',
        name: '六联',
    },
    {
        id: 5956,
        label: '帮助 > Photoshop 帮助...',
        placement: 'MenuBar',
        name: 'Photoshop 帮助...',
    },
    {
        id: 5957,
        label: '编辑 > 搜索',
        placement: 'MenuBar',
        name: '搜索',
    },
    {
        id: 5960,
        label: '窗口 > 排列 > 匹配缩放',
        placement: 'MenuBar',
        name: '匹配缩放',
    },
    {
        id: 5962,
        label: '窗口 > 排列 > 匹配位置',
        placement: 'MenuBar',
        name: '匹配位置',
    },
    {
        id: 5963,
        label: '窗口 > 排列 > 匹配旋转',
        placement: 'MenuBar',
        name: '匹配旋转',
    },
    {
        id: 5964,
        label: '窗口 > 排列 > 全部匹配',
        placement: 'MenuBar',
        name: '全部匹配',
    },
    {
        id: 5966,
        label: '文件 > 共享以供审阅',
        placement: 'MenuBar',
        name: '共享以供审阅',
    },
    {
        id: 5967,
        label: '文件 > 邀请参与编辑...',
        placement: 'MenuBar',
        name: '邀请参与编辑...',
    },
    {
        id: 5980,
        label: '编辑 > 键盘快捷键...',
        placement: 'MenuBar',
        name: '键盘快捷键...',
    },
    {
        id: 5981,
        label: '窗口 > 工作区 > 键盘快捷键和菜单(K)...',
        placement: 'MenuBar',
        name: '键盘快捷键和菜单(K)...',
    },
    {
        id: 5982,
        label: '编辑 > 菜单...',
        placement: 'MenuBar',
        name: '菜单...',
    },
    {
        id: 5983,
        label: '编辑 > 工具栏...',
        placement: 'MenuBar',
        name: '工具栏...',
    },
    {
        id: 5991,
        label: '视图 > 屏幕模式 > 标准屏幕模式',
        placement: 'MenuBar',
        name: '标准屏幕模式',
    },
    {
        id: 5992,
        label: '视图 > 屏幕模式 > 带有菜单栏的全屏模式',
        placement: 'MenuBar',
        name: '带有菜单栏的全屏模式',
    },
    {
        id: 5993,
        label: '视图 > 屏幕模式 > 全屏模式',
        placement: 'MenuBar',
        name: '全屏模式',
    },
    {
        id: 5996,
        label: '窗口 > 排列 > 在窗口中浮动',
        placement: 'MenuBar',
        name: '在窗口中浮动',
    },
    {
        id: 5997,
        label: '窗口 > 排列 > 使所有内容在窗口中浮动',
        placement: 'MenuBar',
        name: '使所有内容在窗口中浮动',
    },
    {
        id: 5998,
        label: '窗口 > 排列 > 将所有内容合并到选项卡中',
        placement: 'MenuBar',
        name: '将所有内容合并到选项卡中',
    },
    {
        id: 6300,
        label: '图层 > 新建填充图层 > 纯色...',
        placement: 'MenuBar',
        name: '纯色...',
    },
    {
        id: 6301,
        label: '图层 > 新建填充图层 > 渐变...',
        placement: 'MenuBar',
        name: '渐变...',
    },
    {
        id: 6302,
        label: '图层 > 新建填充图层 > 图案...',
        placement: 'MenuBar',
        name: '图案...',
    },
    {
        id: 6303,
        label: '图层 > 新建调整图层 > 色阶...',
        placement: 'MenuBar',
        name: '色阶...',
    },
    {
        id: 6304,
        label: '图层 > 新建调整图层 > 曲线...',
        placement: 'MenuBar',
        name: '曲线...',
    },
    {
        id: 6305,
        label: '图层 > 新建调整图层 > 色彩平衡...',
        placement: 'MenuBar',
        name: '色彩平衡...',
    },
    {
        id: 6306,
        label: '图层 > 新建调整图层 > 亮度/对比度...',
        placement: 'MenuBar',
        name: '亮度/对比度...',
    },
    {
        id: 6308,
        label: '图层 > 新建调整图层 > 色相/饱和度...',
        placement: 'MenuBar',
        name: '色相/饱和度...',
    },
    {
        id: 6309,
        label: '图层 > 新建调整图层 > 可选颜色...',
        placement: 'MenuBar',
        name: '可选颜色...',
    },
    {
        id: 6310,
        label: '图层 > 新建调整图层 > 通道混合器...',
        placement: 'MenuBar',
        name: '通道混合器...',
    },
    {
        id: 6311,
        label: '图层 > 新建调整图层 > 渐变映射...',
        placement: 'MenuBar',
        name: '渐变映射...',
    },
    {
        id: 6312,
        label: '图层 > 新建调整图层 > 照片滤镜...',
        placement: 'MenuBar',
        name: '照片滤镜...',
    },
    {
        id: 6313,
        label: '图层 > 新建调整图层 > 反相...',
        placement: 'MenuBar',
        name: '反相...',
    },
    {
        id: 6314,
        label: '图层 > 新建调整图层 > 阈值...',
        placement: 'MenuBar',
        name: '阈值...',
    },
    {
        id: 6315,
        label: '图层 > 新建调整图层 > 色调分离...',
        placement: 'MenuBar',
        name: '色调分离...',
    },
    {
        id: 6332,
        label: '图层 > 智能对象 > 编辑内容',
        placement: 'MenuBar',
        name: '编辑内容',
    },
    {
        id: 6333,
        label: '图层 > 智能对象 > 替换内容...',
        placement: 'MenuBar',
        name: '替换内容...',
    },
    {
        id: 6334,
        label: '图层 > 智能对象 > 导出内容...',
        placement: 'MenuBar',
        name: '导出内容...',
    },
    {
        id: 6337,
        label: '图层 > 新建调整图层 > 颜色查找...',
        placement: 'MenuBar',
        name: '颜色查找...',
    },
    {
        id: 6339,
        label: '图层 > 智能对象 > 转换为链接对象...',
        placement: 'MenuBar',
        name: '转换为链接对象...',
    },
    {
        id: 6340,
        label: '图层 > 智能对象 > 重新链接到文件...',
        placement: 'MenuBar',
        name: '重新链接到文件...',
    },
    {
        id: 6341,
        label: '图层 > 智能对象 > 重新链接到库图形...',
        placement: 'MenuBar',
        name: '重新链接到库图形...',
    },
    {
        id: 6342,
        label: '图层 > 智能对象 > 更新修改的内容',
        placement: 'MenuBar',
        name: '更新修改的内容',
    },
    {
        id: 6343,
        label: '图层 > 智能对象 > 更新所有修改的内容',
        placement: 'MenuBar',
        name: '更新所有修改的内容',
    },
    {
        id: 6345,
        label: '图层 > 智能对象 > 嵌入链接的智能对象',
        placement: 'MenuBar',
        name: '嵌入链接的智能对象',
    },
    {
        id: 6346,
        label: '图层 > 智能对象 > 嵌入所有链接的智能对象',
        placement: 'MenuBar',
        name: '嵌入所有链接的智能对象',
    },
    {
        id: 6347,
        label: '图层 > 智能对象 > 复位变换',
        placement: 'MenuBar',
        name: '复位变换',
    },
    {
        id: 6348,
        label: '图层 > 新建调整图层 > 黑白...',
        placement: 'MenuBar',
        name: '黑白...',
    },
    {
        id: 6351,
        label: '图层 > 视频图层 > 从文件新建视频图层...',
        placement: 'MenuBar',
        name: '从文件新建视频图层...',
    },
    {
        id: 6352,
        label: '图层 > 视频图层 > 新建空白视频图层',
        placement: 'MenuBar',
        name: '新建空白视频图层',
    },
    {
        id: 6353,
        label: '图层 > 视频图层 > 插入空白帧',
        placement: 'MenuBar',
        name: '插入空白帧',
    },
    {
        id: 6354,
        label: '图层 > 视频图层 > 复制帧',
        placement: 'MenuBar',
        name: '复制帧',
    },
    {
        id: 6355,
        label: '图层 > 视频图层 > 删除帧',
        placement: 'MenuBar',
        name: '删除帧',
    },
    {
        id: 6356,
        label: '图层 > 视频图层 > 解释素材...',
        placement: 'MenuBar',
        name: '解释素材...',
    },
    {
        id: 6357,
        label: '图层 > 视频图层 > 替换素材...',
        placement: 'MenuBar',
        name: '替换素材...',
    },
    {
        id: 6358,
        label: '图层 > 视频图层 > 显示已改变的视频',
        placement: 'MenuBar',
        name: '显示已改变的视频',
    },
    {
        id: 6360,
        label: '图层 > 视频图层 > 恢复帧',
        placement: 'MenuBar',
        name: '恢复帧',
    },
    {
        id: 6361,
        label: '图层 > 视频图层 > 恢复所有帧',
        placement: 'MenuBar',
        name: '恢复所有帧',
    },
    {
        id: 6362,
        label: '文件 > 导入 > 视频帧到图层...',
        placement: 'MenuBar',
        name: '视频帧到图层...',
    },
    {
        id: 6363,
        label: '图层 > 视频图层 > 重新载入帧',
        placement: 'MenuBar',
        name: '重新载入帧',
    },
    {
        id: 6400,
        label: '视图 > 32 位预览选项...',
        placement: 'MenuBar',
        name: '32 位预览选项...',
    },
    {
        id: 6432,
        label: '图层 > 智能对象 > 堆栈模式 > 无',
        placement: 'MenuBar',
        name: '无',
    },
    {
        id: 6440,
        label: '滤镜 > 转换为智能滤镜',
        placement: 'MenuBar',
        name: '转换为智能滤镜',
    },
    {
        id: 6478,
        label: '窗口 > 属性',
        placement: 'MenuBar',
        name: '属性',
    },
    {
        id: 6479,
        label: '窗口 > 调整',
        placement: 'MenuBar',
        name: '调整',
    },
    {
        id: 7763,
        label: '窗口 > 渐变',
        placement: 'MenuBar',
        name: '渐变',
    },
    {
        id: 7767,
        label: '窗口 > 图案',
        placement: 'MenuBar',
        name: '图案',
    },
    {
        id: 7772,
        label: '窗口 > 形状',
        placement: 'MenuBar',
        name: '形状',
    },
    {
        id: 7785,
        label: '窗口 > Content Credentials (Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials (Beta)',
    },
    {
        id: 7788,
        label: '窗口 > 材质',
        placement: 'MenuBar',
        name: '材质',
    },
    {
        id: 7789,
        label: '滤镜 > 参数滤镜...',
        placement: 'MenuBar',
        name: '参数滤镜...',
    },
    {
        id: 7800,
        label: '图像 > 应用数据组...',
        placement: 'MenuBar',
        name: '应用数据组...',
    },
    {
        id: 7802,
        label: '图像 > 变量 > 定义...',
        placement: 'MenuBar',
        name: '定义...',
    },
    {
        id: 7803,
        label: '图像 > 变量 > 数据组...',
        placement: 'MenuBar',
        name: '数据组...',
    },
    {
        id: 7805,
        label: '文件 > 导入 > 变量数据组...',
        placement: 'MenuBar',
        name: '变量数据组...',
    },
    {
        id: 7806,
        label: '文件 > 导出 > 数据组作为文件...',
        placement: 'MenuBar',
        name: '数据组作为文件...',
    },
    {
        id: 7900,
        label: '图像 > 分析 > 计数工具',
        placement: 'MenuBar',
        name: '计数工具',
    },
    {
        id: 7930,
        label: '窗口 > 应用程序框架',
        placement: 'MenuBar',
        name: '应用程序框架',
    },
    {
        id: 8820,
        label: '滤镜 > Neural Filters...',
        placement: 'MenuBar',
        name: 'Neural Filters...',
    },
    {
        id: 9066,
        label: '文字 > 面板 > 字符样式面板',
        placement: 'MenuBar',
        name: '字符样式面板',
    },
    {
        id: 9066,
        label: '窗口 > 字符样式',
        placement: 'MenuBar',
        name: '字符样式',
    },
    {
        id: 9067,
        label: '文字 > 面板 > 段落样式面板',
        placement: 'MenuBar',
        name: '段落样式面板',
    },
    {
        id: 9067,
        label: '窗口 > 段落样式',
        placement: 'MenuBar',
        name: '段落样式',
    },
    {
        id: 9068,
        label: '文字 > 面板 > 字形面板',
        placement: 'MenuBar',
        name: '字形面板',
    },
    {
        id: 9068,
        label: '窗口 > 字形',
        placement: 'MenuBar',
        name: '字形',
    },
    {
        id: 9086,
        label: '文字 > OpenType > 对齐替代字',
        placement: 'MenuBar',
        name: '对齐替代字',
    },
    {
        id: 9087,
        label: '文字 > 管理缺失字体',
        placement: 'MenuBar',
        name: '管理缺失字体',
    },
    {
        id: 9100,
        label: '文字 > 语言选项 > 默认功能',
        placement: 'MenuBar',
        name: '默认功能',
    },
    {
        id: 9101,
        label: '文字 > 语言选项 > 东亚语言功能',
        placement: 'MenuBar',
        name: '东亚语言功能',
    },
    {
        id: 9102,
        label: '文字 > 语言选项 > 中东语言功能',
        placement: 'MenuBar',
        name: '中东语言功能',
    },
    {
        id: 9109,
        label: '文字 > 字体预览大小 > 无',
        placement: 'MenuBar',
        name: '无',
    },
    {
        id: 9110,
        label: '文字 > 字体预览大小 > 小',
        placement: 'MenuBar',
        name: '小',
    },
    {
        id: 9111,
        label: '文字 > 字体预览大小 > 中',
        placement: 'MenuBar',
        name: '中',
    },
    {
        id: 9112,
        label: '文字 > 字体预览大小 > 大',
        placement: 'MenuBar',
        name: '大',
    },
    {
        id: 9113,
        label: '文字 > 字体预览大小 > 特大',
        placement: 'MenuBar',
        name: '特大',
    },
    {
        id: 9114,
        label: '文字 > 字体预览大小 > 超大',
        placement: 'MenuBar',
        name: '超大',
    },
    {
        id: 9119,
        label: '文字 > 粘贴 Lorem Ipsum',
        placement: 'MenuBar',
        name: '粘贴 Lorem Ipsum',
    },
    {
        id: 9121,
        label: '文字 > 载入默认文字样式',
        placement: 'MenuBar',
        name: '载入默认文字样式',
    },
    {
        id: 9122,
        label: '文字 > 存储默认文字样式',
        placement: 'MenuBar',
        name: '存储默认文字样式',
    },
    {
        id: 9123,
        label: '文字 > 匹配字体...',
        placement: 'MenuBar',
        name: '匹配字体...',
    },
    {
        id: 9130,
        label: '文字 > 语言选项 > 标准垂直罗马对齐方式',
        placement: 'MenuBar',
        name: '标准垂直罗马对齐方式',
    },
    {
        id: 9131,
        label: '文字 > 语言选项 > 直排内横排',
        placement: 'MenuBar',
        name: '直排内横排',
    },
    {
        id: 9132,
        label: '文字 > 语言选项 > 顶到顶行距',
        placement: 'MenuBar',
        name: '顶到顶行距',
    },
    {
        id: 9133,
        label: '文字 > 语言选项 > 底到底行距',
        placement: 'MenuBar',
        name: '底到底行距',
    },
    {
        id: 9137,
        label: '文字 > 语言选项 > Kashidas',
        placement: 'MenuBar',
        name: 'Kashidas',
    },
    {
        id: 9138,
        label: '文字 > 语言选项 > 默认方向',
        placement: 'MenuBar',
        name: '默认方向',
    },
    {
        id: 9139,
        label: '文字 > 语言选项 > 自左向右字符方向',
        placement: 'MenuBar',
        name: '自左向右字符方向',
    },
    {
        id: 9140,
        label: '文字 > 语言选项 > 自右向左字符方向',
        placement: 'MenuBar',
        name: '自右向左字符方向',
    },
    {
        id: 9143,
        label: '编辑 > 选择性粘贴 > 粘贴且不使用任何格式',
        placement: 'MenuBar',
        name: '粘贴且不使用任何格式',
    },
    {
        id: 9220,
        label: '图层 > 新建 > 画板...',
        placement: 'MenuBar',
        name: '画板...',
    },
    {
        id: 9221,
        label: '图层 > 新建 > 来自图层组的画板',
        placement: 'MenuBar',
        name: '来自图层组的画板',
    },
    {
        id: 9222,
        label: '图层 > 新建 > 来自图层的画板...',
        placement: 'MenuBar',
        name: '来自图层的画板...',
    },
    {
        id: 9252,
        label: '图层 > 新建 > 来自图层的画框...',
        placement: 'MenuBar',
        name: '来自图层的画框...',
    },
    {
        id: 9255,
        label: '图层 > 新建 > 转换为图框',
        placement: 'MenuBar',
        name: '转换为图框',
    },
    {
        id: 9600,
        label: '窗口 > 上下文任务栏',
        placement: 'MenuBar',
        name: '上下文任务栏',
    },
    {
        id: 15004,
        label: '帮助 > 系统信息...',
        placement: 'MenuBar',
        name: '系统信息...',
    },
    {
        id: 15009,
        label: '帮助 > GPU 兼容性...',
        placement: 'MenuBar',
        name: 'GPU 兼容性...',
    },
    {
        id: 15019,
        label: '帮助 > 详细了解生成式积分',
        placement: 'MenuBar',
        name: '详细了解生成式积分',
    },
    {
        id: 15020,
        label: '帮助 > Adobe 生成式 AI 用户准则',
        placement: 'MenuBar',
        name: 'Adobe 生成式 AI 用户准则',
    },
    {
        id: 15201,
        label: '文件 > 搜索 Adobe Stock...',
        placement: 'MenuBar',
        name: '搜索 Adobe Stock...',
    },
    {
        id: 15202,
        label: '文件 > 搜索 Adobe Express 模板...',
        placement: 'MenuBar',
        name: '搜索 Adobe Express 模板...',
    },
    {
        id: 15203,
        label: '帮助 > 实操教程...',
        placement: 'MenuBar',
        name: '实操教程...',
    },
    {
        id: 15204,
        label: '帮助 > 新增功能...',
        placement: 'MenuBar',
        name: '新增功能...',
    },
    {
        id: 17001,
        label: '编辑 > 透视变形',
        placement: 'MenuBar',
        name: '透视变形',
    },
    {
        id: 20006,
        label: '文件 > 版本历史记录',
        placement: 'MenuBar',
        name: '版本历史记录',
    },
    {
        id: 20007,
        label: '窗口 > 版本历史记录',
        placement: 'MenuBar',
        name: '版本历史记录',
    },
    {
        id: 20008,
        label: '窗口 > 注释',
        placement: 'MenuBar',
        name: '注释',
    },
    {
        id: 21000,
        label: '图层 > 智能对象 > 转换为图层',
        placement: 'MenuBar',
        name: '转换为图层',
    },
    {
        id: 21001,
        label: '视图 > 按屏幕大小缩放图层',
        placement: 'MenuBar',
        name: '按屏幕大小缩放图层',
    },
    {
        id: 22003,
        label: '视图 > 参考线 > 编辑所选参考线',
        placement: 'MenuBar',
        name: '编辑所选参考线',
    },
    {
        id: 22004,
        label: '视图 > 参考线 > 清除所选参考线',
        placement: 'MenuBar',
        name: '清除所选参考线',
    },
    {
        id: 22100,
        label: '图层 > 遮住所有对象',
        placement: 'MenuBar',
        name: '遮住所有对象',
    },
    {
        id: 23150,
        label: '滤镜 > 上次滤镜操作',
        placement: 'MenuBar',
        name: '上次滤镜操作',
    },
    {
        id: 23151,
        label: '滤镜 > 上次滤镜操作',
        placement: 'MenuBar',
        name: '上次滤镜操作',
    },
    {
        id: 23152,
        label: '滤镜 > 上次滤镜操作',
        placement: 'MenuBar',
        name: '上次滤镜操作',
    },
    {
        id: 23153,
        label: '滤镜 > 上次滤镜操作',
        placement: 'MenuBar',
        name: '上次滤镜操作',
    },
    {
        id: 'paintbrushTool',
        label: '画笔工具',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: '调整画笔工具',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: '铅笔工具',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: '颜色替换工具',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: '混合器画笔工具',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: '橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: '背景橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: '仿制图章工具',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: '图案图章工具',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: '修复画笔工具',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: '历史记录画笔工具',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: '历史记录艺术画笔工具',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: '涂抹工具',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: '模糊工具',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: '锐化工具',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: '减淡工具',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: '加深工具',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: '海绵工具',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: '红眼工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: '矩形选框工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: '椭圆选框工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: '单行选框工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: '单列选框工具',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: '移动工具',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: '画板工具',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: '套索工具',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: '选区画笔工具',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: '对象选择工具',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: '多边形套索工具',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: '磁性套索工具',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: '魔棒工具',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: '快速选择工具',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: '裁剪工具',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: '透视裁剪工具',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: '切片工具',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: '切片选择工具',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: '魔术橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: '渐变工具',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: '油漆桶工具',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: '路径选择工具',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: '直接选择工具',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: '钢笔工具',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: '自由钢笔工具',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: '弯度钢笔工具',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: '添加锚点工具',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: '删除锚点工具',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: '转换点工具',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: '横排文字工具',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: '直排文字工具',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: '横排文字蒙版工具',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: '直排文字蒙版工具',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: '矩形工具',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: '椭圆工具',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: '三角形工具',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: '多边形工具',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: '直线工具',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: '自定形状工具',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: '图框工具',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: '吸管工具',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: '颜色取样器工具',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: '标尺工具',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: '注释工具',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: '抓手工具',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: '旋转视图工具',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: '缩放工具',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: '修补工具',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: '内容感知移动工具',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: '污点修复画笔工具',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: '移除工具',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: '编辑工具栏...',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: '计数工具',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: '动作',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: '渐变',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: '样式',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: '色板',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: '图案',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: '直方图',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: '信息',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: '路径',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: '形状',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: '工具预设',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: '颜色',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: '通道',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: '图层',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: '图层复合',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: '时间轴',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: '仿制源',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: '测量记录',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: '历史记录',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: '导航器',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: '字符',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: '段落',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: '字符样式',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: '段落样式',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: '字形',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: '注释',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: '属性',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: 'Context Bar : 动态文本',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: '面板 : 动态文本',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: '工具 : 动态文本',
        placement: 'Option',
    },
];
